import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "calendar",
  id: "kennel-cal"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "month-selector" }
const _hoisted_5 = { class: "selected-month" }
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "dates-container" }
const _hoisted_8 = { class: "row-container" }
const _hoisted_9 = { class: "row day-header" }
const _hoisted_10 = { class: "row row-fill" }
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "header-left")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: "icon arrow left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.adjustMonth(-1)))
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("svg", {
            class: "icon chevron chevron-down",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              class: "fill",
              d: "M16.59 8.59L12 13.17L7.41 8.59L6 10L12 16L18 10L16.59 8.59Z"
            })
          ], -1)
        ])),
        _createElementVNode("span", _hoisted_5, _toDisplayString($setup.CONSTS.Months[$props.timeframe.month]) + " " + _toDisplayString($props.timeframe.year), 1),
        _createElementVNode("span", {
          class: "icon arrow right",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.adjustMonth()))
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("svg", {
            class: "icon chevron chevron-down",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              class: "fill",
              d: "M16.59 8.59L12 13.17L7.41 8.59L6 10L12 16L18 10L16.59 8.59Z"
            })
          ], -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "header-right")
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CONSTS.Days, (day, index) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "day lg",
              key: `d-${index}`
            }, _toDisplayString(day), 1))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CONSTS.DAYS_ABBRV, (day, i) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "day sm-md",
              key: `da-${i}`
            }, _toDisplayString(day), 1))
          }), 128))
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentWeeksInMonth, (index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row-container",
          key: `w-${index-1}`
        }, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.daysOfWeek($props.timeframe.year, $props.timeframe.month, index-1), (day, ix) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `dw-${ix}`,
                class: _normalizeClass(["day-bg", {'out-of-month': day.getMonth() !== $props.timeframe.month}]),
                onClick: ($event: any) => ($setup.handleClick(day))
              }, [
                _createVNode($setup["KennelCount"], {
                  day: day.getDate(),
                  month: day.getMonth(),
                  year: day.getFullYear(),
                  kennel: $props.kennel
                }, null, 8, ["day", "month", "year", "kennel"])
              ], 10, _hoisted_11))
            }), 128))
          ])
        ]))
      }), 128))
    ]),
    ($setup.currentKennelCount)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 0,
          onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.currentKennelCount = null))
        }, {
          default: _withCtx(() => [
            _createVNode($setup["KennelCountModal"], {
              date: $setup.currentKennelCount,
              onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.currentKennelCount = null))
            }, null, 8, ["date"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}